import styled, { css } from 'styled-components';
import { devices } from '@/constants/media';

const getItemWidth = (total: number, hasPinned?: boolean) => {
  if (hasPinned) {
    return '100%';
  }

  switch (total) {
    case 1:
    case 2:
      return '100%';
    case 3:
    case 4:
      return `${100 / 2}%`;
    case 5:
    case 6:
      return `${100 / 3}%`;
  }
};

const getItemHeight = (total: number, hasPinned?: boolean) => {
  if (hasPinned) {
    return `${100 / (total - 1)}%`;
  }

  switch (total) {
    case 1:
    case 2:
      return '100%';
    case 3:
    case 4:
    case 5:
    case 6:
      return `${100 / 2}%`;
  }
};

const getItemWidthSm = (total: number, hasPinned?: boolean) => {
  if (hasPinned) {
    return `${100 / (total - 1)}%`;
  }

  switch (total) {
    case 1:
    case 2:
    case 3:
      return '100%';
    case 4:
    case 5:
    case 6:
      return `${100 / 2}%`;
  }
};

const getItemHeightSm = (total: number, hasPinned?: boolean) => {
  if (hasPinned) {
    return '100%';
  }

  switch (total) {
    case 1:
    case 2:
      return '100%';
    case 3:
    case 5:
    case 6:
      return `${100 / 3}%`;
    case 4:
      return `${100 / 2}%`;
  }
};

export const StyledVideoTile = styled.div<{
  $absolute?: boolean;
  $total: number;
  $isPinned?: boolean;
  $hasPinned?: boolean;
  $pinnedWidth?: number;
  $pinnedHeight?: number;
}>`
  overflow: hidden;
  padding: var(--spacing-md);
  transition: all var(--transition-fast);
  ${({
    $total,
    $absolute,
    $isPinned,
    $hasPinned,
    $pinnedWidth,
    $pinnedHeight,
  }) => {
    if ($absolute) {
      return css`
        position: absolute;
        z-index: 4;
        bottom: 0;
        right: 0;
        width: 340px;
        height: fit-content;
        max-height: auto;
        overflow: hidden;
        line-height: 1;
        >div {
          height: fit-content;
          video {
            border-radius: var(--radius-xl);
          }
        }
        .local-avatar {
          height: 230px;
        }
        @media ${devices.sm} {
          width: 120px;
          .local-avatar {
            height: 140px;
          }
        }
      `;
    }

    if ($isPinned) {
      return css`
        position: fixed;
        z-index: 2;
        left: 0;
        top: 0;
        width: ${$pinnedWidth}px;
        height: ${$pinnedHeight}px;
      `;
    }

    if ($total) {
      return css`
        --item-width: ${getItemWidth($total, $hasPinned)};
        --item-height: ${getItemHeight($total, $hasPinned)};
        @media ${devices.sm} {
          --item-width: ${getItemWidthSm($total, $hasPinned)};
          --item-height: ${getItemHeightSm($total, $hasPinned)}; 
        }
        min-width: var(--item-width);
        height: var(--item-height);
        flex: 0 0 var(--item-width);
        position: relative;
      `;
    }
  }}
  @media ${devices.sm} {
    padding: var(--spacing-sm);
  }
`;
